import axios from 'axios'
import { getStore, setStore } from './storage'
import { router } from '../router/index'
import { Message } from 'view-design'
import Util from '@/libs/util'
// import Cookies from 'js-cookie'
// import tool from './tool'
// 统一请求路径前缀
let base = '/admin'
let baseApi = '/api'
let isTK = '/tiku/api'
let isXBZ = '/xbz'
let authExpiryHandled = false
const recentErrorMessages = new Set()

const readableErrorMessage = (message, fallback) => {
  const text = typeof message === 'string' ? message.trim() : ''
  return !text || /^[?\uFFFD\s]+$/.test(text) ? fallback : text
}

const showErrorOnce = message => {
  if (recentErrorMessages.has(message)) return
  recentErrorMessages.add(message)
  Message.error(message)
  setTimeout(() => recentErrorMessages.delete(message), 2000)
}

// 超时设定
axios.defaults.timeout = 60000

axios.interceptors.request.use(
  config => {
    return config
  },
  err => {
    showErrorOnce('请求超时')
    return Promise.resolve(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    const data = response.data
    const requestUrl = response.config && response.config.url || ''
    if (data.success && requestUrl.indexOf('/v3/student/login') !== -1) {
      authExpiryHandled = false
    }
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
      case 401:
        // 未登录 清除已登录状态
        Util.localRem('userInfo')
        Util.localRem('accessToken')
        if (router.history.current.name !== 'login' && !authExpiryHandled) {
          authExpiryHandled = true
          showErrorOnce(readableErrorMessage(data.message, '登录状态已失效，请重新登录'))
          router.replace('/login', () => {
            if (router.history.current.name !== 'login') authExpiryHandled = false
          }, () => {
            if (router.history.current.name !== 'login') authExpiryHandled = false
          })
        }
        break
      case 403:
        // 没有权限
        if (data.message !== null) {
          showErrorOnce(readableErrorMessage(data.message, '暂无访问权限'))
        } else {
          showErrorOnce('暂无访问权限')
        }
        break
      case 500:
        // 错误
        if (data.message !== null) {
          showErrorOnce(readableErrorMessage(data.message, '服务暂时异常，请稍后重试'))
        } else {
          showErrorOnce('服务暂时异常，请稍后重试')
        }
        break
      default:
        return data
    }

    return data
  },
  err => {
    // 返回状态码不为200时候的错误处理
    showErrorOnce(err.toString())
    return Promise.resolve(err)
  }
)
export const getRequestAPI = (url, params, isAdmin) => {
  let accessToken = getStore('accessToken');
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  return axios({
      method: 'get',
      url: `/api${url}`,
      params: params,
      headers: {
          'accessToken': accessToken,
          from: from,
      }
  });
};
export const blobRequest = (url, params, isAdmin, isApi = false) => {
  let accessToken = getStore('accessToken');
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  return axios({
      method: 'post',
      data: params,
      responseType: 'blob',
      url: isAdmin ? `${ isApi ? '/api' : baseAdmin }${url}`:`${base}${url}`,
      transformRequest: [function (data) {
          let ret = '';
          for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
          }
          ret = ret.substring(0, ret.length - 1);
          return ret;
      }],
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'accessToken': accessToken,
          from: from,
      }
  });
};
// headers 传递鉴权 post 请求
export const postRequestApplication = (url, params, paramsObj) => {
  // console.log(params,paramsObj)
  const { accessKey, timestamp, nonce, sign } = Util.md5Encryption(params, true);
  return axios({
      method: 'post',
      url: `${isTK}${url}`,
      data: JSON.stringify(paramsObj),
      headers: {
          'Content-Type': 'application/json',
          'accessKey': accessKey,
          'timestamp': timestamp,
          'nonce': nonce,
          'sign': sign,
      }
  });
};
export const getXBZRequest = (url, params,) => {
  // let accessToken = Util.localGet('accessToken')
  let returnObj = {
    method: 'get',
    url: `${ isXBZ }${url}`,
    params: params,
    // headers: {
      // accessToken: accessToken,
      // from: 'pc'
    // }
  }
  // if (isXBZ && !accessToken) {
  //   delete returnObj.headers.accessToken
  // }
  return axios(returnObj)
}
export const getTKRequest = (url, params) => {
  // let accessToken = Util.localGet('accessToken');
  let returnObj = {
    method: 'get',
    url: `${isTK}${url}`,
    // url: `http://192.168.0.107:8888/api${url}`,
    params: params,
    // headers: {
    //   accessToken: accessToken,
    //   from: 'pc'
    // }
  };
  // if(isTK && !accessToken){
  //   delete returnObj.headers.accessToken;
  // };
  return axios(returnObj);
}
export const postTKRequest = (url, params) => {
  // let accessToken = Util.localGet('accessToken');
  let returnObj = {
    method: 'post',
    url: `${isTK}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded',
    //   accessToken: accessToken,
    //   from: 'pc'
    // }
  };
  // if(isTK && !accessToken){
  //   delete returnObj.headers.accessToken;
  // };
  return axios(returnObj);
}
export const noTokenGetRequest = (url, params) => {
    // let accessToken = getStore('accessToken');
    return axios({
        method: 'get',
        url: `${baseApi}${url}`,
        params: params,
        // headers: {
        //     'accessToken': undefined
        // }
    });
};

export const noTokenPostRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${baseApi}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        }
    });
};
export const getRequest = (url, params,isApi = false) => {
  let accessToken = Util.localGet('accessToken');
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  let returnObj = {
    method: 'get',
    url: `${ isApi ? baseApi : base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
      from: from
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj);
}
export const getRequestData = (url) => {
  
  let returnObj = {
    method: 'get',
    url: `${url}`,
  };
  return axios(returnObj);
}
export const getRequestSteamCard = (url, params,isApi = false) => {
  let accessToken = Util.localGet('accessToken');
  let returnObj = {
    method: 'get',
    url: `${ isApi ? baseApi : base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
      from: 'steamCard'
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj);
}
export const postRequest = (url, params, isApi = false) => {
  let accessToken = Util.localGet('accessToken');
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  let returnObj = {
    method: 'post',
    url: `${ isApi ? baseApi : base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
      from: from
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj);
}

export const uploadRequest = (url, fromData) => {
  let accessToken = Util.localGet('accessToken');
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  let returnObj = {
    method: 'post',
    url: `${base}${url}`,
    data: fromData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
      from: from
    }
  };
  return axios(returnObj);
}

export const putRequest = (url, params, isApi = false) => {
  let accessToken = Util.localGet('accessToken');
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  let returnObj = {
    method: 'put',
    url: `${ isApi ? baseApi : base}${url}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      accessToken: accessToken,
      from: from
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj)
}

export const deleteRequest = (url, params, isApi = false) => {
  let accessToken = Util.localGet('accessToken');
  let returnObj = {
    method: 'delete',
    url: `${ isApi ? baseApi : base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
      from: 'pc'
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj)
}

export const importRequest = (url, params, isApi = false) => {
  let accessToken = Util.localGet('accessToken')
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  let returnObj = {
    method: 'post',
    url: `${ isApi ? baseApi : base}${url}`,
    data: params,
    headers: {
      accessToken: accessToken,
      from: from
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj)
}

export const uploadFileRequest = (url, params, isApi = false) => {
  let accessToken = Util.localGet('accessToken')
  let returnObj = {
    method: 'post',
    url: `${ isApi ? baseApi : base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
      from: 'pc'
    }
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj)
}

export const downloadFileRequest = (url, params, isApi = false) => {
  let accessToken = Util.localGet('accessToken')
  let from = Util.localGet('from');
  if(!from){
    from = 'pc'
  }
  let returnObj = {
    method: 'get',
    url: `${ isApi ? baseApi : base}${url}`,
    params: params,
    headers: {
      accessToken: accessToken,
      from: from
    },
    responseType: 'blob'
  };
  if(isApi && !accessToken){
    delete returnObj.headers.accessToken;
  };
  return axios(returnObj)
}



// WEBPACK FOOTER //
// ./src/libs/axios.js